import { Typography, Button } from 'components/UI'

type Props = {
	hasCollaborators: boolean
	isUserCollaborator: boolean
	onOpenAddCollaboratorModal: () => void
}

const CollaboratorsTitleSection = ({
	hasCollaborators,
	isUserCollaborator,
	onOpenAddCollaboratorModal
}: Props) => (
	<div class='flex justify-between'>
		<div>
			<Typography
				class='mb-2.5'
				color='text-product'
				text='Collaborators'
				variant='h3'
			/>
			{isUserCollaborator ? (
				<Typography
					color='text-black-200'
					text='View Collaborators'
					variant='text2'
				/>
			) : (
				<Typography
					color='text-black-200'
					text={
						hasCollaborators
							? 'Invite users and manage access to your dApp.'
							: "You haven't invited any collaborators yet. Invite users and manage access to your dApp."
					}
					variant='text2'
				/>
			)}
		</div>
		{!isUserCollaborator && hasCollaborators && (
			<Button
				disabled={isUserCollaborator}
				onClick={onOpenAddCollaboratorModal}
				text='Add Collaborators'
			/>
		)}
	</div>
)

export { CollaboratorsTitleSection }
